import * as React from "react";

import { Info } from "lucide-react";

/** A small muted footnote line under a chart/section (e.g. the privacy note). */
const NoteLine = ({ children }: { children: React.ReactNode }) => (
  <div className="mt-4 flex items-start gap-2 text-[12.5px] leading-[1.5] text-ink-500">
    <Info className="mt-px h-3.5 w-3.5 shrink-0 text-gray-400" strokeWidth={1.9} />
    <span>{children}</span>
  </div>
);

export default NoteLine;
